var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSendDark(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 16,
    viewBox: "0 0 15 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.25 7.10697L1.49003 0.106974C1.3378 0.0302641 1.16848 -0.00625804 0.998169 0.000876328C0.827854 0.0080107 0.662189 0.0585645 0.516908 0.147737C0.371627 0.236909 0.251553 0.36174 0.168089 0.510373C0.0846248 0.659007 0.0405416 0.82651 0.0400257 0.996974V6.57697C0.0388092 6.69566 0.0807172 6.81076 0.157964 6.90088C0.235211 6.991 0.342545 7.05002 0.460026 7.06697L10.8 7.99697L0.420026 8.92697C0.302545 8.94392 0.195211 9.00294 0.117964 9.09306C0.0407173 9.18319 -0.00119078 9.29828 2.57606e-05 9.41697V14.997C0.000541629 15.1674 0.0446249 15.3349 0.128089 15.4836C0.211553 15.6322 0.331627 15.757 0.476908 15.8462C0.622189 15.9354 0.787854 15.9859 0.958169 15.9931C1.12848 16.0002 1.2978 15.9637 1.45003 15.887L14.21 8.88697C14.3758 8.8068 14.5162 8.68242 14.6158 8.52754C14.7153 8.37266 14.7702 8.19329 14.7744 8.00921C14.7785 7.82512 14.7317 7.64347 14.6392 7.48427C14.5467 7.32507 14.412 7.19451 14.25 7.10697Z",
    fill: "#8D8D8D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSendDark);
export default __webpack_public_path__ + "static/media/send-dark.d6ab795347b08697350b3c3100e32734.svg";
export { ForwardRef as ReactComponent };